import type { MediaSize } from './MediaSizeToggle'

/**
 * Pixel target for the smallest grid track at each MediaSize.
 * Used by AddToProductSlotGrid and KiReferenceSlots so both grids share the
 * same track sizing rules.
 */
export const IMAGE_SIZES: Record<MediaSize, number> = { S: 120, M: 180, L: 285 }
